import './styles.scss'

interface CarouselDotsProps {
  total: number
  activeIndex: number
  variant?: 'light' | 'dark'
  onDotClick?: (index: number) => void
}

export function CarouselDots({ total, activeIndex, variant = 'light', onDotClick }: CarouselDotsProps) {
  return (
    <div className="carousel-dots">
      {Array.from({ length: total }, (_, index) => (
        <button
          key={index}
          type="button"
          className={`carousel-dots__dot carousel-dots__dot--${variant} ${
            index === activeIndex ? 'carousel-dots__dot--active' : ''
          }`}
          onClick={() => onDotClick?.(index)}
          aria-label={`Go to slide ${index + 1}`}
        />
      ))}
    </div>
  )
}
